import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePermissionViewModel } from '../../pages/admin/permissions/viewmodel/permission-viewmodel';

const TopBar = ({ 
  isMobile, 
  setIsSidebarOpen, 
  toggleSidebar, 
  NotificationSystemComponent,
  notificationProps
}) => {
  const location = useLocation();
  const {hasPermission} = usePermissionViewModel('tableau_de_board')

  // Function to get page title based on current path
  const getPageTitle = () => {
    switch (location.pathname) {
      case '/admin':
        if (!hasPermission('read')) {
          return 'Admin'
        }
        return 'Tableau de bord';
      case '/admin/products':
        return 'Gestion des produits';
      case '/admin/variants':
        return 'Gestion des variantes';
      case '/admin/brands':
        return 'Gestion des marques';
      case '/admin/suppliers':
        return 'Gestion des fournisseurs';
      case '/admin/orders':
        return 'Gestion des commandes';
      case '/admin/platform':
        return 'Gestion des plateformes';
      case '/admin/customers':
        return 'Gestion des clients';
      case '/admin/settings':
        return 'Paramètres';
      case '/admin/facebook-leads':
        return 'Facebook Leads';
      case '/admin/purchases':
        return 'Gestion des achats';
      case '/admin/exchanges':
        return 'Gestion des échanges';
      case '/admin/import':
        return 'Import de Contacts';
      default:
        return 'Admin';
    }
  };

  if (isMobile) {
    return (
      <div className="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3 bg-white shadow-sm flex justify-between items-center">
        <button
          className="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-[#174540]"
          onClick={() => setIsSidebarOpen(true)}
        >
          <span className="sr-only">Ouvrir le menu</span>
          <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Mobile Notifications */}
        <NotificationSystemComponent {...notificationProps} />
      </div>
    );
  }

  return (
    <div className="hidden md:flex md:items-center md:justify-between p-4 bg-white shadow-sm border-b border-gray-200">
      <div className="text-xl font-semibold text-gray-800">
        {getPageTitle()}
      </div>
      
      {/* Desktop Notifications and toggle sidebar */}
      <div className="flex items-center">
        <NotificationSystemComponent {...notificationProps} />
        <button 
          className="ml-2 p-1.5 text-gray-500 hover:text-gray-800 rounded-full hover:bg-gray-100" 
          onClick={toggleSidebar}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default TopBar;